import ShopPayoutIndex from './ShopPayoutIndex';
import ShopPayoutCreate from './ShopPayoutCreate';
import ShopPayoutSettings from './ShopPayoutSettings';
import ShopPayoutSingle from './ShopPayoutSingle';

export default function (app) {

    const settings = ShopPayoutSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    ShopPayoutIndex(app, settings);

    ShopPayoutCreate(app, settings);

    ShopPayoutSingle(app, settings);

}